import defaultBinders from './defaultbinders.js';
// tries to find a binder for given node
export default function lookForBinder(node) {
  for (var i = 0; i < defaultBinders.length; i++) {
    var binder = defaultBinders[i].call(node, node);
    if (binder) {
      return binder;
    }
  }
  return undefined;
}